import * as React from 'react';
import styled from 'styled-components';
import config from 'config';
import { ReactComponent as AlmaTalentLogo } from 'assets/logos/alma_talent_logo.svg';
import { CommonLink } from 'components/common';

const Link = styled(CommonLink)`
    width: 140px;
    margin: 5px 0 0 10px;
`;

const Logo = () => (
    <Link href={`${config.logoLink}/`}>
        <AlmaTalentLogo />
    </Link>
);

export default Logo;
